<mat-card appearance="outlined" class="flat mt-10" style="margin-bottom: 10px">
    <div style="margin-bottom: 10px"
    data-tx-key="label.gb.patientdetailsbr">
        <h3 [id]="identifierService.labelId('viewPatientDetails', 'patientdetailsbr')" class="merlin-header" >{{ labels['label.gb.patientdetailsbr'] }}</h3>
    </div>
    <div *ngIf="displayViewUI()">
        <div *ngIf="!isCountryFrance">
            <div class="row">
                <div class="col-xs-4 col-md-4 col-lg-3">
                    <div *ngIf="isJapanseLocale">
                        <div [id]="identifierService.labelId('viewPatientDetails', 'altLastName')" class="labelText" data-tx-key="label.gb.alternatelastname">
                            {{ labels['label.gb.alternatelastname'] }}
                        </div>
                        <div
                            class="infoText"
                            style="margin-bottom: 10px"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewAlternateFirstName'
                                )
                            "
                        >
                            {{ patRes?.patient?.altLastName ? patRes?.patient?.altLastName : "--" }}
                        </div>
                        <div [id]="identifierService.labelId('viewPatientDetails', 'altFirstName')" class="labelText" data-tx-key="label.gb.alternatefirstname">
                            {{ labels['label.gb.alternatefirstname'] }}
                        </div>
                        <div
                            class="infoText"
                            style="margin-bottom: 10px"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewAlternateFirstName'
                                )
                            "
                        >
                            {{ patRes?.patient?.altFirstName ?  patRes?.patient?.altFirstName : "--"}}
                        </div>
                    </div>
                    <ng-template #firstNameLabel>
                        <div [id]="identifierService.labelId('viewPatientDetails', 'firstName')" class="labelText" data-tx-key="label.gb.firstname">
                            {{ labels['label.gb.firstname'] }}
                        </div>
                        <div
                            class="infoText"
                            style="margin-bottom: 10px"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewFirstName'
                                )
                            "
                        >
                            {{ patRes?.patient?.firstName ? patRes?.patient?.firstName: "--" }}
                        </div>
                    </ng-template>
                    <ng-template #middleNameLabel>
                        <div [id]="identifierService.labelId('viewPatientDetails', 'middleName')" class="labelText" *ngIf="!isJapanseLocale" data-tx-key="label.gb.middlename">
                            {{ labels['label.gb.middlename'] }}
                        </div>
                        <div
                            class="infoText"
                            style="margin-bottom: 10px"
                            *ngIf="!isJapanseLocale"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewMiddleName'
                                )
                            "
                        >
                            {{ patRes?.patient?.middleName ? patRes?.patient?.middleName : "--" }}
                        </div>
                    </ng-template>
                    <ng-template #lastNameLabel>
                        <div [id]="identifierService.labelId('viewPatientDetails', 'lastName')" class="labelText" data-tx-key="label.gb.lastname">
                            {{ labels['label.gb.lastname'] }}
                        </div>
                        <div
                            class="infoText"
                            style="margin-bottom: 10px"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewLastName'
                                )
                            "
                        >
                            {{ patRes?.patient?.lastName ? patRes?.patient?.lastName : "--" }}
                        </div>
                    </ng-template>
                    <!-- Locale-based order -->
                    <ng-container *ngIf="isJapanseLocale; else nonJapaneseNameOrder">
                        <ng-container *ngTemplateOutlet="lastNameLabel"></ng-container>
                        <ng-container *ngTemplateOutlet="firstNameLabel"></ng-container>
                    </ng-container>

                    <ng-template #nonJapaneseNameOrder>
                        <ng-container *ngTemplateOutlet="firstNameLabel"></ng-container>
                        <ng-container *ngTemplateOutlet="middleNameLabel"></ng-container>
                        <ng-container *ngTemplateOutlet="lastNameLabel"></ng-container>
                    </ng-template>
                    <div [id]="identifierService.labelId('viewPatientDetails', 'dateOfBirth')" class="labelText" data-tx-key="label.gb.date_of_birth">
                        {{ labels['label.gb.date_of_birth'] }}
                    </div>
                    <div
                        class="infoText"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewDateOfBirthStr'
                            )
                        "
                    >
                        {{ patRes?.patient?.dateOfBirthStr ? patRes?.patient?.dateOfBirthStr : "--" }}
                    </div>
                </div>
                <div class="col-xs-4 col-md-4 col-lg-3">
                    <div [id]="identifierService.labelId('viewPatientDetails', 'patRecordNo')" class="labelText" data-tx-key="label.gb.pat_record_no">
                        {{ labels['label.gb.pat_record_no'] }}
                    </div>
                    <div
                        class="infoText"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewPatientNum'
                            )
                        "
                    >
                        {{ patRes?.patient?.patientNum ? patRes?.patient?.patientNum : "--" }}
                    </div>
                    <div [id]="identifierService.labelId('viewPatientDetails', 'merlinNetNumber')"
                        class="labelText"
                        [innerHtml]="labels['label.gb.Merlin.net_number']"
                     data-tx-key="label.gb.Merlin.net_number"></div>
                    <div
                        class="infoText"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewMerlinNetId'
                            )
                        "
                    >
                        {{ patRes?.patient?.merlinNetId ? patRes?.patient?.merlinNetId : "--" }}
                    </div>
                    <div [id]="identifierService.labelId('viewPatientDetails', 'clinicLoc')" class="labelText" data-tx-key="label.gb.clinic_loc">
                        {{ labels['label.gb.clinic_loc'] }}
                    </div>
                    <div
                        class="infoText"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewClinicLocation'
                            )
                        "
                    >
                        {{ getClinicLocation() ? getClinicLocation(): "--" }}
                    </div>
                    <div [id]="identifierService.labelId('viewPatientDetails', 'enrollment')" class="labelText" data-tx-key="label.gb.merlin_net_enrollment">
                        {{ labels['label.gb.merlin_net_enrollment'] }}
                    </div>
                    <div
                        class="infoText"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewEnrollmentDate'
                            )
                        "
                    >
                        {{ patRes?.patient?.enrollmentDate ? patRes?.patient?.enrollmentDate : "--" }}
                    </div>
                </div>
                <div class="col-xs-4 col-md-4 col-lg-3">
                    <ng-container *ngIf="isUSAClinic">
                        <div [id]="identifierService.labelId('viewPatientDetails', 'race')" class="labelText" data-tx-key="label.gb.race">
                            {{ labels['label.gb.race'] }}
                        </div>
                        <div
                            class="infoText"
                            style="margin-bottom: 10px"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewRace'
                                )
                            "
                        >
                            {{ getRace() ? getRace() : "--" }}
                        </div>
                    </ng-container>
                    <div [id]="identifierService.labelId('viewPatientDetails', 'gender')" class="labelText" data-tx-key="label.gb.gender">
                        {{ labels['label.gb.gender'] }}
                    </div>
                    <div
                        class="infoText"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewGender'
                            )
                        "
                    >
                        {{ getGender() ? getGender() : "--" }}
                    </div>
                    <div [id]="identifierService.labelId('viewPatientDetails', 'patPrefers')" class="labelText" data-tx-key="label.gb.pat_prefers">
                        {{ labels['label.gb.pat_prefers'] }}
                    </div>
                    <div
                        class="infoText"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewLang'
                            )
                        "
                    >
                        {{ getLang() ? getLang() : "--" }}
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="isCountryFrance">
            <div class="row">
                <div class="col-xs-4 col-md-4 col-lg-3">
                    <div class="labelText ins_tool" data-tx-key="label.gb.INSnumber_long">
                       <span [id]="identifierService.labelId('viewPatientDetails', 'insnumberLong')">{{ labels['label.gb.INSnumber_long'] }}</span>
                       <mat-icon
                            class="p-l-10 mat-icon-orange"
                            [mdePopoverTriggerFor]="
                            dataRatesPopover
                            "
                        >
                            <img src="assets/images/question.png" />
                        </mat-icon>
                        <mde-popover
                            #dataRatesPopover="mdePopover"
                            [mdePopoverOverlapTrigger]="false"
                            mdePopoverPositionX="after"
                            mdePopoverPositionY="above"
                            mdePopoverArrowOffsetX="15"
                        >
                            <mat-card
                                appearance="outlined"
                                style="max-width: 640px"
                            >
                                <mat-card-content>
                                    <div [id]="identifierService.labelId('view-patient-details', 'toolTipHtml')" [innerHTML]="
                                        toolTipHtmlLabel
                                    "></div>
                                </mat-card-content>
                            </mat-card>
                        </mde-popover>
                    </div>
                    <div
                        class="infoText"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewFrenchinsNumber'
                            )
                        "
                    >
                    <div [id]="identifierService.labelId('viewPatientDetails', 'insNumberValue')" class="text__ins">
                        {{ patRes?.patient?.insNumber ? patRes?.patient?.insNumber : "--" }}
                    </div>
                    </div>
                    <div [id]="identifierService.labelId('viewPatientDetails', 'frFirstName')" class="labelText" data-tx-key="label.gb.firstname_long">
                        {{ labels['label.gb.firstname_long'] }}
                    </div>
                    <div
                        class="infoText wrap-text"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewFrenchFirstName'
                            )
                        "
                    >
                        {{ patRes?.patient?.firstName ? patRes?.patient?.firstName : "--" }}
                    </div>
                    <div [id]="identifierService.labelId('viewPatientDetails', 'frGivenNames')" class="labelText" data-tx-key="label.gb.givennames_long">
                        {{ labels['label.gb.givennames_long'] }}
                    </div>
                    <div
                        class="infoText wrap-text"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewFrenchGivenName'
                            )
                        "
                        [maxLength]="100"
                    >
                        {{ patRes?.patient?.givenNames ? patRes?.patient?.givenNames : "--" }}
                    </div>
                    <div [id]="identifierService.labelId('view-patient-details', 'firstnameUsedLong')" class="labelText" data-tx-key="label.gb.firstname_used_long" [innerHtml]="labels['label.gb.firstname_used_long']">
                    </div>
                    <div
                        class="infoText wrap-text"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewFrenchusedGivenName'
                            )
                        "
                    >
                        {{ patRes?.patient?.usedGivenName ? patRes?.patient?.usedGivenName : "--" }}
                    </div>
                    <div [id]="identifierService.labelId('viewPatientDetails', 'frLastName')" class="labelText" data-tx-key="label.gb.lastname_long">
                        {{ labels['label.gb.lastname_long'] }}
                    </div>
                    <div
                        class="infoText wrap-text"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewFrenchLastName'
                            )
                        "
                    >
                        {{ patRes?.patient?.lastName ? patRes?.patient?.lastName : "--" }}
                    </div>
                    <div [id]="identifierService.labelId('view-patient-details', 'lastnameUsedLong')" class="labelText" data-tx-key="label.gb.lastname_used_long" [innerHtml]="labels['label.gb.lastname_used_long']">
                    </div>
                    <div
                        class="infoText wrap-text"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewFrenchUsedLastName'
                            )
                        "
                    >
                        {{ patRes?.patient?.usedLastName ? patRes?.patient?.usedLastName : "--" }}
                    </div>
                </div>
                <div class="col-xs-4 col-md-4 col-lg-3">
                    <div [id]="identifierService.labelId('viewPatientDetails', 'frSSN')" class="labelText" data-tx-key="label.gb.SSN">
                        {{ labels['label.gb.SSN'] }}
                    </div>
                    <div
                        class="infoText"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'franceSSN'
                            )
                        "
                    >
                        {{ patRes?.patient?.franceSsn ? patRes?.patient?.franceSsn : "--" }}
                    </div>
                    <div [id]="identifierService.labelId('viewPatientDetails', 'frDateOfBirth')" class="labelText" data-tx-key="label.gb.date_of_birth_long">
                        {{ labels['label.gb.date_of_birth_long'] }}
                    </div>
                    <div
                        class="infoText"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewFrenchDateOfBirthStr'
                            )
                        "
                    >
                        {{ patRes?.patient?.dateOfBirthStr ? patRes?.patient?.dateOfBirthStr : "--" }}
                    </div>
                    <div [id]="identifierService.labelId('viewPatientDetails', 'frPatRecordNo')" class="labelText" data-tx-key="label.gb.pat_record_no">
                        {{ labels['label.gb.pat_record_no'] }}
                    </div>
                    <div
                        class="infoText"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewFrenchPatientNum'
                            )
                        "
                    >
                        {{ patRes?.patient?.patientNum ? patRes?.patient?.patientNum : "--" }}
                    </div>
                    <div [id]="identifierService.labelId('viewPatientDetails', 'frenchMerlinNetNumber')"
                        class="labelText"
                        [innerHtml]="labels['label.gb.Merlin.net_number']"
                     data-tx-key="label.gb.Merlin.net_number"></div>
                    <div
                        class="infoText"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewFrenchMerlinNetId'
                            )
                        "
                    >
                        {{ patRes?.patient?.merlinNetId ? patRes?.patient?.merlinNetId : "--" }}
                    </div>
                    <div [id]="identifierService.labelId('viewPatientDetails', 'frClinicLoc')" class="labelText" data-tx-key="label.gb.clinic_loc">
                        {{ labels['label.gb.clinic_loc'] }}
                    </div>
                    <div
                        class="infoText"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewFrenchClinicLocation'
                            )
                        "
                    >
                        {{ getClinicLocation() ? getClinicLocation() : "--" }}
                    </div>

                    <div [id]="identifierService.labelId('viewPatientDetails', 'frEnrollment')" class="labelText" data-tx-key="label.gb.merlin_net_enrollment">
                        {{ labels['label.gb.merlin_net_enrollment'] }}
                    </div>
                    <div
                        class="infoText"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewFrenchEnrollmentDate'
                            )
                        "
                    >
                        {{ patRes?.patient?.enrollmentDate ? patRes?.patient?.enrollmentDate : "--" }}
                    </div>
                </div>
                <div class="col-xs-4 col-md-4 col-lg-3">
                    <div [id]="identifierService.labelId('viewPatientDetails', 'frOID')" class="labelText" data-tx-key="label.gb.OID">
                        {{ labels['label.gb.OID'] }}
                    </div>
                    <div
                        class="infoText"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewFrenchOidNumber'
                            )
                        "
                    >
                        {{ patRes?.patient?.oidNumber }}
                    </div>
                    <div [id]="identifierService.labelId('viewPatientDetails', 'frGender')" class="labelText" data-tx-key="label.gb.gender_long">
                        {{ labels['label.gb.gender_long'] }}
                    </div>
                    <div
                        class="infoText"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewFrenchGender'
                            )
                        "
                    >
                        {{ getGender() ? getGender() : "--" }}
                    </div>
                    <div [id]="identifierService.labelId('viewPatientDetails', 'frBirthCode')" class="labelText" data-tx-key="label.gb.birth_code_long">
                        {{ labels['label.gb.birth_code_long'] }}
                    </div>
                    <div
                        class="infoText"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewFrenchPlaceOfBirth'
                            )
                        "
                    >
                        {{ patRes?.patient?.placeOfBirth ? patRes?.patient?.placeOfBirth : "--" }}
                    </div>
                    <div [id]="identifierService.labelId('viewPatientDetails', 'frPatPrefers')" class="labelText" data-tx-key="label.gb.pat_prefers">
                        {{ labels['label.gb.pat_prefers'] }}
                    </div>
                    <div
                        class="infoText"
                        style="margin-bottom: 10px"
                        [id]="
                            identifierService.dropdownId(
                                'patient-details',
                                'viewFrenchLang'
                            )
                        "
                    >
                        {{ getLang() ? getLang() : "--" }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-card>
